import React, { FC } from 'react';

type PropsT = {
  fill?: string;
};

const SearchIcon: FC<PropsT> = ({ fill = 'currentColor' }) => (
  <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.6843 13.6143C11.4083 14.589 9.81393 15.168 8.08429 15.168C3.8956 15.168 0.5 11.7725 0.5 7.58398C0.5 3.39546 3.8956 0 8.08429 0C12.273 0 15.6686 3.39546 15.6686 7.58398C15.6686 9.31378 15.0894 10.9083 14.1144 12.1843L20.2118 18.2814C20.6023 18.6719 20.6023 19.305 20.2118 19.6955L20.1959 19.7114C19.8054 20.1019 19.1722 20.1019 18.7817 19.7114L12.6843 13.6143ZM14.1517 7.58398C14.1517 10.9348 11.4352 13.6512 8.08429 13.6512C4.73334 13.6512 2.01686 10.9348 2.01686 7.58398C2.01686 4.23316 4.73334 1.5168 8.08429 1.5168C11.4352 1.5168 14.1517 4.23316 14.1517 7.58398Z"
      fill={fill}
    />
  </svg>
);

export default SearchIcon;
import React, { FC } from 'react';

type PropsT = {
  fill?: string;
};

const SearchIcon: FC<PropsT> = ({ fill = 'currentColor' }) => (
  <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.6843 13.6143C11.4083 14.589 9.81393 15.168 8.08429 15.168C3.8956 15.168 0.5 11.7725 0.5 7.58398C0.5 3.39546 3.8956 0 8.08429 0C12.273 0 15.6686 3.39546 15.6686 7.58398C15.6686 9.31378 15.0894 10.9083 14.1144 12.1843L20.2118 18.2814C20.6023 18.6719 20.6023 19.305 20.2118 19.6955L20.1959 19.7114C19.8054 20.1019 19.1722 20.1019 18.7817 19.7114L12.6843 13.6143ZM14.1517 7.58398C14.1517 10.9348 11.4352 13.6512 8.08429 13.6512C4.73334 13.6512 2.01686 10.9348 2.01686 7.58398C2.01686 4.23316 4.73334 1.5168 8.08429 1.5168C11.4352 1.5168 14.1517 4.23316 14.1517 7.58398Z"
      fill={fill}
    />
  </svg>
);

export default SearchIcon;
